import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const InstapathPlatform = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f9f9f9',
                textAlign: 'center',
                paddingTop: '10%',
            }}
        >
            <Typography variant="h4" sx={{ marginBottom: '16px', fontWeight: 600 }}>
                Instapath Cloud
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: '24px', color: '#555' }}>
                Explore our cloud solutions designed for drone operations and management.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={() => navigate('/')}
                sx={{
                    textTransform: 'none',
                    padding: '8px 16px',
                    borderRadius: '8px',
                }}
            >
                Go Back to Home
            </Button>
        </Box>
    );
};

export default InstapathPlatform;